import { Button, Grid } from '@mui/material';
import RadarChart from 'react-svg-radar-chart';
import 'react-svg-radar-chart/build/css/index.css'
import { Trans } from 'react-i18next';
import { useContext, useEffect, useState } from 'react';
import { useRef } from "react";
import { BusinessManagerContext } from 'src/contexts/BusinessManagerContext';

export default function GraphGlobalSkillsSummary(props) {
    const {
        setChartDataContext
    } = useContext(BusinessManagerContext);
    const chartRef = useRef(null);
    const [chartDataValue, setChartDataValue] = useState([
        {
            data: {
                categoryType1: 0,
                categoryType2: 0,
                categoryType3: 0,
                categoryType4: 0,
                categoryType5: 0,
                categoryType6: 0,
                categoryType7: 0,
                categoryType8: 0,
                categoryType9: 0
            },
            meta: { color: '#00c072' }
        }
    ])
    const [captions, setCaptions] = useState({
        categoryType1: '',
        categoryType2: '',
        categoryType3: '',
        categoryType4: '',
        categoryType5: '',
        categoryType6: '',
        categoryType7: '',
        categoryType8: '',
        categoryType9: ''
    })
    const refValue = 4;

    useEffect(() => {
        if (props.data != undefined && props.data != null) {
            if (props.data.length == 9) {
                setCaptions({
                    categoryType1: props.data[0].skillCategTypeName,
                    categoryType2: props.data[1].skillCategTypeName,
                    categoryType3: props.data[2].skillCategTypeName,
                    categoryType4: props.data[3].skillCategTypeName,
                    categoryType5: props.data[4].skillCategTypeName,
                    categoryType6: props.data[5].skillCategTypeName,
                    categoryType7: props.data[6].skillCategTypeName,
                    categoryType8: props.data[7].skillCategTypeName,
                    categoryType9: props.data[8].skillCategTypeName
                })
                setChartDataValue([
                    {
                        data: { // ref
                            categoryType1: (props.data[0].objectifMaturity / refValue),
                            categoryType2: (props.data[1].objectifMaturity / refValue),
                            categoryType3: (props.data[2].objectifMaturity / refValue),
                            categoryType4: (props.data[3].objectifMaturity / refValue),
                            categoryType5: (props.data[4].objectifMaturity / refValue),
                            categoryType6: (props.data[5].objectifMaturity / refValue),
                            categoryType7: (props.data[6].objectifMaturity / refValue),
                            categoryType8: (props.data[7].objectifMaturity / refValue),
                            categoryType9: (props.data[8].objectifMaturity / refValue)
                        },
                        meta: { color: '#00c072' }
                    },
                    {
                        data: { // manager
                            categoryType1: (props.data[0].managerVision / refValue),
                            categoryType2: (props.data[1].managerVision / refValue),
                            categoryType3: (props.data[2].managerVision / refValue),
                            categoryType4: (props.data[3].managerVision / refValue),
                            categoryType5: (props.data[4].managerVision / refValue),
                            categoryType6: (props.data[5].managerVision / refValue),
                            categoryType7: (props.data[6].managerVision / refValue),
                            categoryType8: (props.data[7].managerVision / refValue),
                            categoryType9: (props.data[8].managerVision / refValue)
                        },
                        meta: { color: 'blue' }
                    },
                    {
                        data: { // employee
                            categoryType1: (props.data[0].employeeVision / refValue),
                            categoryType2: (props.data[1].employeeVision / refValue),
                            categoryType3: (props.data[2].employeeVision / refValue),
                            categoryType4: (props.data[3].employeeVision / refValue),
                            categoryType5: (props.data[4].employeeVision / refValue),
                            categoryType6: (props.data[5].employeeVision / refValue),
                            categoryType7: (props.data[6].employeeVision / refValue),
                            categoryType8: (props.data[7].employeeVision / refValue),
                            categoryType9: (props.data[8].employeeVision / refValue)
                        },
                        meta: { color: 'yellow' }
                    }
                ]);
            }
        }
    }, [props.data]);

    useEffect(() => {
        if (chartRef.current) {
            setChartDataContext(chartRef.current)
        }
    }, [props.data, chartRef]);

    return (
        <Grid container ref={chartRef}>
            <Grid item xs={9} >
                <RadarChart
                    captions={captions}
                    data={chartDataValue}
                    size={500}
                />
            </Grid>
            <Grid item xs={3} >
                <table style={{ textAlign: 'left', marginTop: 10 }}>
                    <tbody>
                        <tr>
                            <td style={{ backgroundColor: '#00c072', width: 40, height: 10 }}></td>
                            <td>&nbsp;&nbsp;<Trans>eepBm.tableSummary.title1</Trans></td>
                        </tr>
                        <tr>
                            <td style={{ backgroundColor: 'blue', width: 40, height: 10 }}></td>
                            <td>&nbsp;&nbsp;<Trans>eepBm.tableSummary.title3</Trans></td>
                        </tr>
                        <tr>
                            <td style={{ backgroundColor: 'yellow', width: 40, height: 10 }}></td>
                            <td>&nbsp;&nbsp;<Trans>eepBm.tableSummary.title2</Trans></td>
                        </tr>
                    </tbody>
                </table>
            </Grid>
        </Grid>
    );
}